import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { styledWithTheme } from "../../context";
import { Row } from "../../layout";
export var TagList = styledWithTheme('ul')(function (_ref) {
  var theme = _ref.theme;
  return {
    listStyleType: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    paddingLeft: 0,
    margin: 0,
    marginBottom: "-".concat(theme.selectors.space('S100'), "px"),
    '& > li': {
      marginBottom: theme.selectors.space('S100')
    }
  };
});
export var TagListItem = /*#__PURE__*/_styled(Row.withComponent('li', {
  target: "e168s66n1"
}), {
  target: "e168s66n0"
})(process.env.NODE_ENV === "production" ? {
  name: "4giot",
  styles: "overflow-x:hidden;padding-top:2px;padding-bottom:2px;display:block;padding-right:8px;"
} : {
  name: "4giot",
  styles: "overflow-x:hidden;padding-top:2px;padding-bottom:2px;display:block;padding-right:8px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2hlbHBlcnMvdGFnLWxpc3QvVGFnTGlzdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBaUIwRCIsImZpbGUiOiIuLi8uLi8uLi8uLi9zcmMvc3VibW9kdWxlcy9oZWxwZXJzL3RhZy1saXN0L1RhZ0xpc3QudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBzdHlsZWRXaXRoVGhlbWUgfSBmcm9tICcuLi8uLi9jb250ZXh0JztcbmltcG9ydCB7IFJvdyB9IGZyb20gJy4uLy4uL2xheW91dCc7XG5cbmV4cG9ydCBjb25zdCBUYWdMaXN0ID0gc3R5bGVkV2l0aFRoZW1lKCd1bCcpKCh7IHRoZW1lIH0pID0+ICh7XG4gIGxpc3RTdHlsZVR5cGU6ICdub25lJyxcbiAgZGlzcGxheTogJ2ZsZXgnLFxuICBmbGV4V3JhcDogJ3dyYXAnLFxuICBwYWRkaW5nTGVmdDogMCxcbiAgbWFyZ2luOiAwLFxuICBtYXJnaW5Cb3R0b206IGAtJHt0aGVtZS5zZWxlY3RvcnMuc3BhY2UoJ1MxMDAnKSBhcyBudW1iZXJ9cHhgLFxuICAnJiA+IGxpJzoge1xuICAgIG1hcmdpbkJvdHRvbTogdGhlbWUuc2VsZWN0b3JzLnNwYWNlKCdTMTAwJykgYXMgbnVtYmVyXG4gIH1cbn0pKTtcblxuZXhwb3J0IGNvbnN0IFRhZ0xpc3RJdGVtID0gc3R5bGVkKFJvdy53aXRoQ29tcG9uZW50KCdsaScpKWBcbiAgb3ZlcmZsb3cteDogaGlkZGVuO1xuICBwYWRkaW5nLXRvcDogMnB4O1xuICBwYWRkaW5nLWJvdHRvbTogMnB4O1xuICBkaXNwbGF5OiBibG9jaztcbiAgcGFkZGluZy1yaWdodDogOHB4O1xuYDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});